import { useContext } from "react";
import { getMonthStandaloneName } from "../../../functions/src/api/dates";
import { langContext } from "../../api/Lang";

const el = {
    navLabel: "Μηνιαίο Μενού",
    allergensList: "Λίστα με αλλεργιογόνα",
    weekWord: "Εβδομάδα",
    menuNotAvailable: "Το μενού δεν είναι διαθέσιμο",
    sideDishCourseType: "ΣΥΝΟΔΕΥΤΙΚΟ",
    dessertCourseType: "ΕΠΙΔΟΡΠΙΟ",
    menuPrefix: "ΜΕΝΟΥ",
    sideDishHeading: "Συνοδευτικό",
    dessertHeading: "Επιδόρπιο",
    newMenuBannerTitle: "Νέο Μενού έχει ξεκινήσει!",
    newMenuBannerBody:
        "Ανακοινώνουμε με χαρά το νέο μενού που σχεδιάστηκε από την Gefsinus Catering!",
    printMenu: "Εκτύπωση μενού",
    printMenuEmpty: "Δεν υπάρχει μενού για αυτόν τον μήνα.",
    printMenuError: "Δεν ήταν δυνατό το άνοιγμα της προεπισκόπησης εκτύπωσης.",
};

const en: typeof el = {
    navLabel: "Monthly Menu",
    allergensList: "List of allergens",
    weekWord: "Week",
    menuNotAvailable: "Menu is not available",
    sideDishCourseType: "SIDE DISH",
    dessertCourseType: "DESSERT",
    menuPrefix: "MENU",
    sideDishHeading: "Side dish",
    dessertHeading: "Dessert",
    newMenuBannerTitle: "New Menu is out!",
    newMenuBannerBody:
        "We're excited to announce that Gefsinus Catering has designed a new menu!",
    printMenu: "Print menu",
    printMenuEmpty: "There is no menu for this month.",
    printMenuError: "Could not open print preview.",
};

const monthlyMenuLangs = { el, en };

export function useMonthlyMenuStrings() {
    const [lang] = useContext(langContext);
    const s = monthlyMenuLangs[lang];
    return {
        ...s,
        /** `monthIndex` 0 = January — same as `Date.getMonth()`. */
        monthName: (monthIndex: number) =>
            getMonthStandaloneName(lang, new Date(2025, monthIndex, 1)),
    };
}
